import { Api } from "./Api";

export default {
  get(params, headers) {
    return Api.get("/v1/domains/get" + params, {
      headers: headers
    });
  },
  getClientDomains(headers = { Accept: "application/json" }) {
    console.log("🚀 ~ get ~ params: 1");
    return Api.get("v1/domains", {
      headers: headers
    });
  },
  searchByTags(tags) {
    return Api.get("/v1/domains/searchByTags" + tags);
  },
  addTags(website_id, tags) {
    return Api.post(`/v1/domains/addTags/${website_id}?${tags}`);
  },
  removeTags(website_id, tags) {
    return Api.post(`/v1/domains/removeTags/${website_id}?${tags}`);
  },
  show(id = "") {
    return Api.get("/v1/domains" + id);
  },
  delete(domainId) {
    return Api.delete("/v1/domains/" + domainId);
  },
  store(json) {
    return Api.post("/v1/domains", json);
  },
  update(domainId, json) {
    return Api.put("/v1/domains/" + domainId, json);
  },
  getDomainFile(params) {
    return Api.post(`/v1/files/generateJavaScriptFileByDomain${params}`)
    //return Api.post(`/v1/files/generateJavaScriptFileByDomain` + params)
  },
  getUnitFile(params, json) {
    //return Api.post(`/v1/files/generateJavaScriptFileByDomain?filename=${fileName}&website_id=${website_id}`)
    return Api.post(`/v1/files/generateUnitFile` + params, json)
  },
  generateJavaScriptZipByDomains(payload) {
    return Api.post(`/v1/files/generateJavaScriptZipByDomains`, payload, {
      responseType: "blob"
    })
  },
};
